export default __webpack_public_path__ + "static/media/slider-nexx-1.38ff9e02.jpg";